import type en from "../en/overview";
import type { Messages } from "../../types";

const ar: Messages<typeof en> = {
  metaTitle: "نظرة عامة",
  welcomeBack: "مرحبًا بعودتك",
  welcomeBackName: "مرحبًا بعودتك، {name}",
  happeningIn: "إليك آخر المستجدات في {store}.",

  // Range picker
  dateRange: "الفترة الزمنية",
  rangeToday: "اليوم",
  range7d: "7 أيام",
  range30d: "30 يومًا",
  range90d: "90 يومًا",
  salesFor_today: "مبيعات اليوم",
  salesFor_7d: "المبيعات خلال آخر 7 أيام",
  salesFor_30d: "المبيعات خلال آخر 30 يومًا",
  salesFor_90d: "المبيعات خلال آخر 90 يومًا",

  // Metrics
  testExcluded: "باستثناء طلبات وضع الاختبار · المبالغ بعملة {currency}",
  paidOrders: "الطلبات المدفوعة",
  grossSales: "إجمالي المبيعات",
  netSales: "صافي المبيعات",
  netSub: "الإجمالي − الخصومات − المبالغ المستردة",
  aov: "متوسط قيمة الطلب",
  pendingPayment: "مدفوعات معلّقة",
  pendingSub: "عدد الطلبات: {count} · لم تُستلم بعد",
  pendingSub_one: "طلب واحد · لم يُستلم بعد",
  refunds: "المبالغ المستردة",
  def_paidOrders: "الطلبات المقدَّمة خلال هذه الفترة والتي تأكّد دفعها (مدفوعة أو مستردة جزئيًا أو مستردة أو متنازع عليها). تُستثنى طلبات وضع الاختبار.",
  def_gross: "مجموع المبالغ الفرعية للمنتجات قبل الخصومات، للطلبات التي تأكّد دفعها. لا يشمل الشحن ولا المبالغ الضريبية وحدها. تُستثنى طلبات وضع الاختبار.",
  def_net: "صافي المبيعات = إجمالي المبيعات − الخصومات − المبالغ المستردة خلال هذه الفترة. تُستثنى طلبات وضع الاختبار.",
  def_aov: "متوسط قيمة الطلب = (إجمالي المبيعات − الخصومات) ÷ عدد الطلبات المدفوعة.",
  def_pending: "مجموع الطلبات المفتوحة التي ما زالت بانتظار الدفع (مثل التحويل البنكي أو الدفع عند الاستلام أو المدفوعات الإلكترونية غير المكتملة). هذه الأموال لم تُستلم بعد.",
  def_refunds: "عمليات الاسترداد الناجحة خلال هذه الفترة، بغض النظر عن تاريخ تقديم الطلب.",
  def_collected: "المبالغ التي حصّلها مزوّدو الدفع لديك أو التي عُلِّمت كمستلمة للمدفوعات غير الإلكترونية، قبل المبالغ المستردة. لا تشمل رسوم المزوّدين لأنها تُقتطع من طرف مزوّدك.",
  def_customers: "عدد عناوين البريد الإلكتروني المختلفة للعملاء الذين لديهم طلب مدفوع خلال هذه الفترة.",
  def_repeat: "العملاء (منذ البداية) الذين لديهم أكثر من طلب مدفوع، من بين جميع العملاء الذين لديهم طلب مدفوع.",
  chartTitle: "المبيعات بعد الخصومات يوميًا",
  chartDesc: "الطلبات المدفوعة فقط، حسب تاريخ الطلب.",
  chartLabel: "المبيعات اليومية — {range}",
  fullAnalytics: "التحليلات الكاملة ←",
  noPaidOrdersPeriod: "لا توجد طلبات مدفوعة في هذه الفترة بعد.",
  salesHidden: "أرقام المبيعات متاحة للأدوار التي تملك صلاحية الوصول إلى التحليلات.",

  // Recent orders
  recentOrders: "أحدث الطلبات",
  allOrders: "كل الطلبات ←",
  noOrdersYet: "لا توجد طلبات بعد",
  ordersWillShow: "ستظهر الطلبات هنا بمجرد أن يُتمّ العملاء عمليات الشراء.",
  publishToReceive: "انشر متجرك لتبدأ في استقبال الطلبات.",
  colOrder: "الطلب",
  colCustomer: "العميل",
  colPayment: "الدفع",
  colFulfillment: "التنفيذ",
  testBadge: "اختبار",
  fin_pending: "معلّق",
  fin_awaiting_action: "بانتظار إجراء",
  fin_authorized: "مصرَّح به",
  fin_paid: "مدفوع",
  fin_partially_refunded: "مسترد جزئيًا",
  fin_refunded: "مسترد",
  fin_failed: "فشل",
  fin_cancelled: "ملغى",
  fin_disputed: "متنازع عليه",
  ful_unfulfilled: "غير منفَّذ",
  ful_partially_fulfilled: "منفَّذ جزئيًا",
  ful_fulfilled: "منفَّذ",
  ful_not_required: "غير مطلوب",

  // Low stock
  lowStock: "مخزون منخفض",
  lowStockDesc: "المنتجات النشطة التي بلغ مخزونها حدّ التنبيه أو أقل.",
  inventoryLink: "المخزون ←",
  nothingLow: "لا يوجد منتج بمخزون منخفض.",
  sku: "رمز المنتج (SKU) {sku}",
  outOfStock: "نفد من المخزون",
  leftInStock: "المتبقي: {count}",

  // Your store
  yourStore: "متجرك",
  draftNotVisible: "مسودة — غير مرئي للعملاء",
  address: "العنوان",
  alsoAt: "وأيضًا: {url}",
  publicationSettings: "إعدادات النشر",

  // Needs attention
  needsAttention: "يتطلب انتباهك",
  noIssues: "لا توجد مشكلات في الدفع أو التنفيذ حاليًا.",
  atCheckout: "عند الدفع: {methods}",
  issue_paidUnfulfilled: "طلبات مدفوعة بانتظار التنفيذ: {count}",
  issue_paidUnfulfilled_one: "طلب مدفوع واحد بانتظار التنفيذ",
  issue_failed: "مدفوعات فشلت خلال آخر 7 أيام: {count}",
  issue_failed_one: "فشلت عملية دفع واحدة خلال آخر 7 أيام",
  issue_disputed: "مدفوعات متنازع عليها: {count}",
  issue_disputed_one: "عملية دفع واحدة متنازع عليها",
  issue_awaiting: "طلبات مفتوحة بانتظار الدفع (لم يُستلم بعد): {count}",
  issue_awaiting_one: "طلب مفتوح واحد بانتظار الدفع (لم يُستلم بعد)",
  issue_provider: "{provider}: {state}",
  issue_providerError: "{provider}: {state} — {error}",
  issue_noPayment: "لا توجد أي وسيلة دفع مفعّلة — لا يمكن للعملاء إتمام الشراء",
  payState_not_connected: "غير متصل",
  payState_setup_required: "يتطلب الإعداد",
  payState_connected: "متصل · غير مفعّل",
  payState_test_mode: "مفعّل عند الدفع · وضع الاختبار",
  payState_active: "مفعّل عند الدفع",
  payState_connection_problem: "مشكلة في الاتصال",
  payState_reauth_required: "يتطلب إعادة التفويض",
  payState_unavailable: "غير متاح مؤقتًا",
  payState_not_supported: "غير مدعوم حاليًا",

  // Launch checklist
  launchChecklist: "قائمة الإطلاق",
  launchChecklistDesc: "أكمل هذه الخطوات لتبدأ البيع. يعتمد التقدّم على الإعداد الفعلي لمتجرك.",
  checklistLinksDesc: "يقودك كل عنصر إلى المكان الذي يمكنك إكماله فيه.",
  continueSetup: "متابعة الإعداد",
  blockersCount: "عناصر يجب إصلاحها قبل النشر: {count}",
  blockersCount_one: "يجب إصلاح عنصر واحد قبل النشر.",
  viewRequirements: "عرض متطلبات الإطلاق ←",
  stepsDone: "اكتملت {done} من {total} خطوات",
  launchProgress: "تقدّم الإطلاق",
  srDone: "(مكتمل)",
  srTodo: "(قيد الانتظار)",
  srOptional: "(اختياري)",
  optionalBadge: "اختياري",
  doneBadge: "مكتمل",
  check_store_created: "إنشاء متجرك",
  check_branding: "إضافة شعارك وهويتك البصرية",
  check_products: "إضافة منتج",
  check_payments: "إعداد وسائل الدفع",
  check_payments_tested: "اختبار وسائل الدفع",
  check_shipping: "إعداد الشحن",
  check_policies: "مراجعة سياسات متجرك",
  check_domain: "ربط نطاق مخصص",
  check_published: "نشر متجرك",
  checkDetail_products: "منتج نشط واحد على الأقل له سعر.",
  checkDetail_payments: "اربط حساب الدفع الخاص بك أو فعّل وسيلة دفع غير إلكترونية.",
  blocker_suspended: "تم إيقاف هذا المتجر من طرف المنصة. تواصل مع الدعم.",
  blocker_contactEmail: "أضف بريدًا إلكترونيًا للتواصل في إعدادات المتجر.",
  blocker_homePage: "يحتاج متجرك إلى صفحة رئيسية.",
  blocker_product: "أضف منتجًا نشطًا واحدًا على الأقل.",
  blocker_payment: "فعّل وسيلة دفع واحدة على الأقل جاهزة لإتمام الشراء.",
  blocker_shipping: "أنت تبيع منتجات مادية — أضف منطقة شحن بسعر واحد على الأقل.",
  warning_policies: "ما زالت صفحات السياسات تحتوي على نص القالب. راجعها قبل الإطلاق.",
  warning_onlineUntested: "بعض وسائل الدفع الإلكترونية المفعّلة لم تجتز اختبار الاتصال.",
  warning_testMode: "إحدى وسائل الدفع في وضع الاختبار — لا يمكن للعملاء الدفع بها فعليًا.",

  // Errors / access
  errTitle: "حدث خطأ ما",
  errBody: "تعذّر تحميل هذه الصفحة. تحقّق من اتصالك وحاول مرة أخرى.",
  errForbiddenTitle: "ليس لديك صلاحية الوصول إلى هذه الصفحة",
  errForbiddenBody: "دورك في هذا المتجر لا يشمل هذا القسم. اطلب الصلاحية من مالك المتجر.",
  noAccessTitle: "ليس لديك صلاحية الوصول إلى هذا القسم",
  noAccessBody: "دورك في {store} هو {role}، وهو لا يشمل هذا القسم. اطلب الصلاحية من مالك المتجر إذا احتجت إليها.",
  backToOverview: "العودة إلى النظرة العامة",

  // Onboarding
  setupTitle: "إعداد متجرك",
  setupDesc: "إعداد موجَّه خطوة بخطوة. يُحفظ تقدّمك تلقائيًا — يمكنك المغادرة والعودة في أي وقت.",
  skipForNow: "تخطٍّ مؤقتًا",
  setupSteps: "خطوات الإعداد",
  stepOf: "الخطوة {step} من {total}",
  step_branding: "الهوية البصرية",
  step_product: "المنتج الأول",
  step_payments: "المدفوعات",
  step_shipping: "الشحن",
  step_taxes: "الضرائب",
  step_policies: "السياسات",
  step_domain: "النطاق",
  step_preview: "المعاينة",
  step_publish: "النشر",
  skipStep: "تخطّي هذه الخطوة",
  goToOverview: "الانتقال إلى النظرة العامة",
  logoTitle: "أضف شعارك",
  logoIntro: "يظهر شعارك في رأس واجهة المتجر وفي رسائل البريد الإلكتروني وعلامة تبويب المتصفح.",
  logoLabel: "الشعار",
  logoHint: "تعطي صورة PNG أو صورة شبيهة بـ SVG بخلفية شفافة أفضل نتيجة.",
  saveLogo: "حفظ الشعار",
  logoSaved: "تم حفظ الشعار.",
  errUploadLogo: "ارفع شعارًا أولًا.",
  colorsInBuilder: "يتم ضبط الألوان والخطوط والتخطيط في",
  colorsInBuilderLink: "منشئ المتجر",
  productTitle: "أضف منتجك الأول",
  productIntro: "ابدأ بمنتج واحد — يمكنك إضافة الخيارات والمزيد من الصور وإعدادات تحسين محركات البحث لاحقًا في المحرّر الكامل.",
  productAlready: "لديك بالفعل منتج نشط. يمكنك إضافة منتج آخر هنا أو المتابعة.",
  productName: "اسم المنتج",
  productNamePh: "مثال: كوب خزفي مصنوع يدويًا",
  stock: "المخزون",
  stockHint: "اتركه فارغًا لعدم تتبّع المخزون.",
  typePhysical: "مادي (يُشحن)",
  typeService: "خدمة (بدون شحن)",
  imageOptional: "صورة (اختياري)",
  addProduct: "إضافة المنتج",
  fullProductEditor: "استخدام محرّر المنتجات الكامل (المنتجات الرقمية، الخيارات) ←",
  errEnterPrice: "أدخل السعر.",
  productActive: "أصبح «{title}» نشطًا في الكتالوج.",
  productFallback: "المنتج",
  paymentsTitle: "اختر طريقة دفع عملائك",
  paymentsIntro: "تصل المدفوعات مباشرة إلى حساباتك الخاصة. اربط حسابك على Stripe أو PayPal، أو اقبل الدفع عند الاستلام / التحويل البنكي — لا تحصّل المنصة أي مدفوعات نيابةً عنك ولا يوجد حساب احتياطي.",
  customersCanPay: "يمكن للعملاء الدفع عبر:",
  cantCheckout: "لا يمكن للعملاء إتمام الشراء حتى تفعّل وسيلة دفع واحدة على الأقل.",
  connectStripePaypal: "ربط Stripe أو PayPal",
  cod: "الدفع عند الاستلام",
  codHint: "يدفع العملاء عند الاستلام؛ وتعلّم الطلبات كمدفوعة عند استلامك المال.",
  enabledInCheckout: "مفعّل عند الدفع",
  enableCod: "تفعيل الدفع عند الاستلام",
  bankTransfer: "التحويل البنكي",
  bankDetails: "البيانات البنكية المعروضة للعملاء",
  bankDetailsHint: "اسم صاحب الحساب، رقم IBAN / رقم الحساب، البنك، ومرجع الدفع المطلوب استخدامه.",
  enableBank: "تفعيل التحويل البنكي",
  askOwnerPayments: "اطلب من مالك المتجر أو أحد المسؤولين إعداد المدفوعات.",
  shippingTitle: "إعداد الشحن",
  shippingIntro: "أضف سعرًا ثابتًا للطلبات التي تُسلَّم داخل {country}. يمكنك إضافة مناطق وأنواع أسعار أخرى لاحقًا.",
  shippingNotRequired: "ليست لديك منتجات مادية نشطة حاليًا، لذا فالشحن غير مطلوب. أعِدّه إذا كنت ستبيع منتجات مادية.",
  shippingHasRate: "لديك سعر شحن نشط واحد على الأقل.",
  rateName: "اسم السعر",
  standardShipping: "الشحن العادي",
  freeShipping: "شحن مجاني",
  priceZeroHint: "أدخل 0 للشحن المجاني.",
  freeOver: "شحن مجاني للطلبات التي تتجاوز",
  noFreeShipping: "بدون شحن مجاني",
  deliveryEstimate: "مدة التوصيل المتوقعة",
  deliveryEstimatePh: "مثال: من 2 إلى 4 أيام عمل",
  saveShippingRate: "حفظ سعر الشحن",
  allShippingSettings: "كل إعدادات الشحن ←",
  shippingSetUp: "تم إعداد الشحن إلى {country}.",
  taxesIntro: "حدّد ما إذا كانت أسعارك تشمل الضريبة وأضف النسب التي يجب عليك تحصيلها.",
  taxResponsibleTitle: "أنت مسؤول عن نسب الضرائب",
  taxResponsibleBody: "يطبّق Storelancer النسب التي تُدخلها؛ ولا يحدّد الضرائب المطبّقة على نشاطك ولا يحسب الضرائب حسب الولاية القضائية تلقائيًا. استشر مستشارًا ضريبيًا.",
  openTaxSettings: "فتح إعدادات الضرائب",
  markReviewed: "تعليم كمراجَع",
  policiesTitle: "راجع سياساتك",
  policiesIntro: "أُنشئ متجرك بصفحات قوالب لسياسات الاسترداد والشحن والخصوصية والشروط. عدّلها لتطابق طريقة عملك الفعلية قبل الإطلاق.",
  editPages: "تعديل الصفحات",
  policiesReviewed: "لقد راجعت سياساتي",
  domainTitle: "ربط نطاق (اختياري)",
  domainIntro: "لدى متجرك بالفعل عنوان مجاني على المنصة. يمكنك ربط نطاق تملكه في أي وقت.",
  connectDomain: "ربط نطاق",
  skipFreeAddress: "تخطٍّ — استخدام العنوان المجاني",
  previewTitle: "عاين متجرك",
  previewIntro: "شاهد واجهة متجرك تمامًا كما سيراها العملاء، قبل أي شخص آخر.",
  openPreview: "فتح المعاينة ↗",
  looksGood: "يبدو جيدًا — متابعة",
  publishIntro: "عندما يصبح كل شيء جاهزًا، انشر متجرك من صفحة الإطلاق. لا يُنشر أي شيء تلقائيًا.",
  stillRequired: "ما زال مطلوبًا قبل النشر",
  storeIsLive: "متجرك منشور الآن.",
  everythingInPlace: "كل المتطلبات مستوفاة.",
  goToPublish: "الانتقال إلى الإطلاق والنشر",
  errUnknownStep: "خطوة غير معروفة",

  // Launch & publish
  publishDesc: "تحقّق مما تبقّى قبل أن يتمكّن العملاء من زيارة متجرك والشراء منه.",
  thingsToFix: "عناصر يجب إصلاحها قبل النشر: {count}",
  thingsToFix_one: "عنصر واحد يجب إصلاحه قبل النشر",
  readyToPublish: "جاهز للنشر",
  allRequirementsMet: "تم استيفاء جميع متطلبات الإطلاق.",
  allStepsComplete: "اكتملت جميع الخطوات المطلوبة.",
  recommendedBeforeLaunch: "يُنصح به قبل الإطلاق",
  publication: "النشر",
  firstPublished: "نُشر لأول مرة في {date}.",
  onlyOwnerPublish: "يمكن لمالك المتجر أو المسؤول فقط نشر هذا المتجر أو إلغاء نشره.",
  suspendedCantPublish: "تم إيقاف هذا المتجر من طرف المنصة ولا يمكن نشره.",
  unpublishConfirmTitle: "إلغاء نشر متجرك؟",
  unpublishConfirmBody: "لن يتمكّن العملاء بعد الآن من تصفّح المتجر أو الشراء. تُحفظ الطلبات والمنتجات والإعدادات، ويمكنك إعادة النشر في أي وقت. يمكن لمزوّد الدفع إتمام عمليات الدفع الجارية.",
  unpublishStore: "إلغاء نشر المتجر",
  publishStore: "نشر المتجر",
  fixRedFirst: "أصلح العناصر المعروضة باللون الأحمر أولًا. ستتم إعادة فحص متجرك عند النشر.",
  publishConfirmTitle: "نشر متجرك؟",
  publishConfirmBody: "ستصبح واجهة متجرك مرئية للجميع، ويمكن للعملاء تقديم الطلبات باستخدام وسائل الدفع التي فعّلتها.",
  publishNow: "النشر الآن",
  previewStore: "معاينة المتجر ↗",
  publicAddresses: "العناوين العامة",
  platformAddress: "العنوان على المنصة",
  primaryDomain: "النطاق الأساسي (مُتحقَّق منه)",
  connectDomainIn: "اربط نطاقًا مخصصًا من",
  addressesNotAvailable: "تعرض هذه العناوين صفحة «غير متاح» حتى تنشر متجرك.",
  storeOffline: "متجرك غير متصل الآن. يرى العملاء صفحة «غير متاح».",
};

export default ar;
